import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }
  public setSession(key: string, value: any): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  public getSession(key: string): any {
    return JSON.parse(window.sessionStorage.getItem(key) || '{}')
  }

  public destroySession(key: string): void {
    window.sessionStorage.removeItem(key);
  }

  public setLocal(key: string, value: any): void {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  public getLocal<T>(key: string, fallback: T): T {
    try {
      const rawValue = window.localStorage.getItem(key);
      return rawValue ? (JSON.parse(rawValue) as T) : fallback;
    } catch {
      return fallback;
    }
  }

  public destroyLocal(key: string): void {
    window.localStorage.removeItem(key);
  }

}
